import { ConfigProvider, Segmented, Tabs } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';
import ReversePanel from './ReversePanel';
import ForwardPanel from './ForwardPanel';
import MotorLibraryPanel from './MotorLibraryPanel';
import ModelLibraryPanel from './ModelLibraryPanel';
import { MotorLibraryProvider } from './motorStore';
import type { SupportedLang } from './i18n';

export default function App() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage ?? 'zh') as SupportedLang;
  const antdLocale = lang === 'en' ? enUS : zhCN;

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{ token: { colorPrimary: '#1677ff', borderRadius: 6 } }}
    >
      <MotorLibraryProvider>
        <div className="app-shell">
          <header className="app-header">
            <div className="app-header-row">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <img src="/logo.png" alt="诺曼森" style={{ height: 48, width: 'auto' }} />
                <div>
                  <h1>{t('header.title')}</h1>
                  <p>{t('header.subtitle')}</p>
                </div>
              </div>
              <Segmented<SupportedLang>
                size="small"
                value={lang}
                onChange={(v) => i18n.changeLanguage(v)}
                options={[
                  { label: '中文', value: 'zh' },
                  { label: 'EN', value: 'en' },
                ]}
              />
            </div>
          </header>

          <main className="app-content">
            <Tabs
              defaultActiveKey="reverse"
              size="large"
              items={[
                { key: 'reverse', label: t('tabs.reverse'), children: <ReversePanel /> },
                { key: 'forward', label: t('tabs.forward'), children: <ForwardPanel /> },
                { key: 'library', label: t('tabs.library'), children: <MotorLibraryPanel /> },
                { key: 'models', label: t('tabs.models'), children: <ModelLibraryPanel /> },
              ]}
            />
          </main>

          <footer className="app-footer">{t('footer')}</footer>
        </div>
      </MotorLibraryProvider>
    </ConfigProvider>
  );
}
